import classnames from 'classnames/bind'
import { GlobalThemeColors } from '~/@types/colors'
import { PropsWithClassName } from '~/@types/generic'
import { GlobalTextPreset } from '~/@types/text-preset'

import ShopifyRichText, {
  ShopifyRichTextBlock,
} from '~/components/Abstracts/ShopifyRichText'
import Image, { ImageProps } from '~/components/UI/Image'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

const IMAGE_SIZES = [{ ratio: 1 }]

export type ProductPromoDataProps = {
  title: string
  text: ShopifyRichTextBlock
  image: ImageProps
}

type ProductPromoProps = PropsWithClassName<{
  data: ProductPromoDataProps
}>

function ProductPromo({ className, data }: ProductPromoProps) {
  const titleStyle = useStyle({
    textPreset: GlobalTextPreset.Title12Haffer,
    color: GlobalThemeColors.MineShaft,
  })

  const textStyle = useStyle({
    textPreset: GlobalTextPreset.Text12Haffer,
    color: GlobalThemeColors.DoveGray,
  })

  if (!data) return null

  return (
    <div className={cx(className, css.ProductPromo)}>
      <div className={css.left}>
        {data?.title && (
          <h3 className={cx(css.title, titleStyle)}>{data.title}</h3>
        )}
        {data?.text && (
          <ShopifyRichText
            className={cx(css.richtext, textStyle)}
            render={data.text}
            withoutCtaTextStyle
          />
        )}
      </div>
      {data?.image && (
        <Image
          className={css.image}
          {...data.image}
          ratio={css.ratio}
          sizesFromBreakpoints={IMAGE_SIZES}
          layout="fill"
          objectFit="cover"
          asPlaceholder
          priority
        />
      )}
    </div>
  )
}

export default ProductPromo
